import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRTagList from '../../NRTagList/NRTagList';

const ScopeFormatter = ({ value: propValue, row }) => {
  // Use row.scope if available (it's the original array of objects),
  // otherwise fallback to value (which might be the string from getCellValue)
  const value = Array.isArray(row?.scope) ? row.scope : Array.isArray(propValue) ? propValue : [];

  return <NRTagList tags={value} isScope={true} />;
};

export const NRSBOMScopeProvider = props => <DataTypeProvider formatterComponent={ScopeFormatter} {...props} />;
